module.exports = __webpack_public_path__ + "static/media/pdfDarkMode.33741bc2.svg";